import Store from './Store';

const ArticleAttributesStore = new Store('articles/active/attributes');

export {ArticleAttributesStore};